import {
  type ApiRoleStrategy,
  ROLES,
  api,
  stringifyQueryObj,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useLoyaltySummaryApi = ({
  year,
  adherentId,
}: { year: number; adherentId?: string }) => {
  const { endpoint, queryKey } = useRoleConf(apiRoleConf(adherentId))
  const queryParams = stringifyQueryObj({ year })

  const { data: summary, isLoading } = useQuery({
    queryKey: [...queryKey, year],
    queryFn: () => api.get<ApiLoyaltySummary>(`${endpoint}?${queryParams}`),
  })

  return { summary, isLoading }
}

interface ApiLoyaltySummary {
  earnedPoint: number
  expectedPoint: number
  lastYearEarnedPoints: number
  ratio: number
}

const presidentApiRoleConf = (adherentId: string) => ({
  endpoint: `/api/loyalties/upp/adherent/${adherentId}/summary`,
  queryKey: ["loyalties", "upp", "adherent", adherentId, "summary"],
})

const adherentApiRoleConf = {
  endpoint: "/api/loyalties/my-adherent/summary",
  queryKey: ["loyalties", "my-adherent", "summary"],
}

const apiRoleConf = (adherentId?: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: adherentApiRoleConf,
  [ROLES.ADHERENT_TEAM]: adherentApiRoleConf,
  ...(adherentId && {
    [ROLES.UPP_PRESIDENT]: presidentApiRoleConf(adherentId),
    [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf(adherentId),
    [ROLES.ADMIN]: {
      endpoint: `/api/loyalties/adherent/${adherentId}/summary`,
      queryKey: ["loyalties", "adherent", adherentId, "summary"],
    },
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/loyalties/my-sector/adherent/${adherentId}/summary`,
      queryKey: ["loyalties", "my-sector", "adherent", adherentId, "summary"],
    },
  }),
})
